import { render } from "./ArticuloNoticia.vue?vue&type=template&id=c6103328&scoped=true"
import script from "./ArticuloNoticia.vue?vue&type=script&lang=js"
export * from "./ArticuloNoticia.vue?vue&type=script&lang=js"

import "./ArticuloNoticia.vue?vue&type=style&index=0&id=c6103328&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6103328"]])

export default __exports__